import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./GLOBAL/components/auth/ProtectedRoute";
import PublicRoute from "./GLOBAL/components/auth/PublicRoute";
import LoginPage from "./GLOBAL/pages/auth/LoginPage";
import RegisterPage from "./GLOBAL/pages/auth/RegisterPage";
import OTPVerificationPage from "./GLOBAL/pages/auth/OTPVerificationPage";
import PricingPage from "./GLOBAL/pages/onboarding/PricingPage";
import PickPlanPage from "./GLOBAL/pages/discovery/PickPlanPage";
import PaymentPage from "./GLOBAL/pages/onboarding/PaymentPage";
import ProfileSetupPage from "./GLOBAL/pages/onboarding/ProfileSetupPage";
import PersonalizePage from "./GLOBAL/pages/onboarding/PersonalizePage";
import OnboardingLoadingPage from "./GLOBAL/pages/onboarding/OnboardingLoadingPage";
import HomePage from "./GLOBAL/pages/home/HomePage";
import DiscoveryPage from "./GLOBAL/pages/discovery/DiscoveryPage";
import DiscoveryCategoryPage from "./GLOBAL/pages/discovery/DiscoveryCategoryPage";
import DetailsPage from "./GLOBAL/pages/details/DetailsPage";
import SearchPage from "./GLOBAL/pages/search/SearchPage";
import CategoryPage from "./GLOBAL/pages/category/CategoryPage";
import WatchlistPage from "./GLOBAL/pages/watchlist/WatchlistPage";
import SettingsPage from "./GLOBAL/pages/settings/SettingsPage";
import AccountPage from "./GLOBAL/pages/settings/AccountPage";
import SubscriptionPage from "./GLOBAL/pages/settings/SubscriptionPage";
import VideoPlayerPage from "./GLOBAL/pages/player/VideoPlayerPage";
// Temporarily hidden per client: Live Show, TV Channels
// import LiveShowPage from "./GLOBAL/pages/live/LiveShowPage";
// import LiveShowDetailPage from "./GLOBAL/pages/live/LiveShowDetailPage";
// import TvChannelsPage from "./GLOBAL/pages/live/TvChannelsPage";
import BrandPage from "./GLOBAL/pages/brand/BrandPage";
// import UpgradePlanPage from "./GLOBAL/pages/settings/UpgradePlanPage";
// import RentalDetailsPage from "./GLOBAL/pages/details/RentalDetailsPage";
import ParentalPage from "./GLOBAL/pages/settings/ParentalPage";
import SubtitlePage from "./GLOBAL/pages/settings/SubtitlePage";
import ManageDevicePage from "./GLOBAL/pages/settings/ManageDevicePage";
import SocialAccountPage from "./GLOBAL/pages/settings/SocialAccountPage";

import NotificationSettingsPage from "./GLOBAL/pages/settings/NotificationSettingsPage";
import ContentRatingPage from "./GLOBAL/pages/settings/ContentRatingPage";
import ParentalDetailPage from "./GLOBAL/pages/settings/ParentalDetailPage";
import ViewActivityPage from "./GLOBAL/pages/settings/ViewActivityPage";
import ProfilePinPage from "./GLOBAL/pages/settings/ProfilePinPage";
// Temporarily hidden per client: Podcast
// import PodcastPage from "./GLOBAL/pages/podcast/PodcastPage";
// import PodcastDetailPage from "./GLOBAL/pages/podcast/PodcastDetailPage";
import GenreCategoryPage from "./GLOBAL/pages/genre/GenreCategoryPage";
import TermsConditionsPage from "./GLOBAL/pages/legal/TermsConditionsPage";
import PrivacyPolicyPage from "./GLOBAL/pages/legal/PrivacyPolicyPage";
import PaymentCallbackPage from "./GLOBAL/pages/payment/PaymentCallbackPage";
import "./_global.scss";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* ===== Public Routes (redirect to /home if already logged in) ===== */}
        <Route index element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/otp-verification" element={<PublicRoute><OTPVerificationPage /></PublicRoute>} />

        {/* ===== Onboarding Flow (public — user hasn't completed setup yet) ===== */}
        <Route path="/onboarding/pricing" element={<PricingPage />} />
        <Route path="/onboarding/register" element={<RegisterPage />} />
        <Route path="/onboarding/payment" element={<PaymentPage />} />
        <Route path="/onboarding/profiles" element={<ProfileSetupPage />} />
        <Route path="/onboarding/personalize" element={<PersonalizePage />} />
        <Route path="/onboarding/loading" element={<OnboardingLoadingPage />} />

        {/* ===== Protected Routes (require authentication) ===== */}
        <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/discover" element={<ProtectedRoute><DiscoveryPage /></ProtectedRoute>} />
        <Route path="/discover/product/:productId/plan" element={<ProtectedRoute><PickPlanPage /></ProtectedRoute>} />
        <Route path="/discover/product/:productId/:name" element={<ProtectedRoute><DiscoveryCategoryPage /></ProtectedRoute>} />
        <Route path="/discover/product/:productId" element={<ProtectedRoute><DiscoveryCategoryPage /></ProtectedRoute>} />
        <Route path="/discover/:uid/:name" element={<ProtectedRoute><DiscoveryCategoryPage /></ProtectedRoute>} />
        <Route path="/discover/:uid" element={<ProtectedRoute><DiscoveryCategoryPage /></ProtectedRoute>} />
        <Route path="/details/:id" element={<ProtectedRoute><DetailsPage /></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
        <Route path="/category/:name" element={<ProtectedRoute><CategoryPage /></ProtectedRoute>} />
        <Route path="/rent" element={<ProtectedRoute><GenreCategoryPage /></ProtectedRoute>} />
        <Route path="/rent/:genre" element={<ProtectedRoute><GenreCategoryPage /></ProtectedRoute>} />
        <Route path="/watchlist" element={<ProtectedRoute><WatchlistPage /></ProtectedRoute>} />
        <Route path="/player/:id" element={<ProtectedRoute><VideoPlayerPage /></ProtectedRoute>} />
        {/* Temporarily hidden per client: Live Show, TV Channels */}
        {/* <Route path="/live" element={<ProtectedRoute><LiveShowPage /></ProtectedRoute>} /> */}
        {/* <Route path="/tv-channels" element={<ProtectedRoute><TvChannelsPage /></ProtectedRoute>} /> */}
        {/* <Route path="/tv-channels/:matchId" element={<ProtectedRoute><TvChannelsPage /></ProtectedRoute>} /> */}
        {/* <Route path="/live/:id" element={<ProtectedRoute><LiveShowDetailPage /></ProtectedRoute>} /> */}
        <Route path="/brand/:name" element={<ProtectedRoute><BrandPage /></ProtectedRoute>} />
        {/* <Route path="/rentals" element={<ProtectedRoute><UpgradePlanPage /></ProtectedRoute>} /> */}
        {/* <Route path="/rentals/:id" element={<ProtectedRoute><RentalDetailsPage /></ProtectedRoute>} /> */}
        {/* <Route path="/genre/:name" element={<ProtectedRoute><GenreCategoryPage /></ProtectedRoute>} /> */}
        {/* Temporarily hidden per client: Podcast */}
        {/* <Route path="/podcast" element={<ProtectedRoute><PodcastPage /></ProtectedRoute>} /> */}
        {/* <Route path="/podcast/:id" element={<ProtectedRoute><PodcastDetailPage /></ProtectedRoute>} /> */}

        {/* ===== Protected Settings Routes ===== */}
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/settings/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/settings/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
        {/* <Route path="/settings/upgrade" element={<ProtectedRoute><UpgradePlanPage /></ProtectedRoute>} /> */}
        <Route path="/settings/parental" element={<ProtectedRoute><ParentalPage /></ProtectedRoute>} />
        <Route path="/settings/subtitle" element={<ProtectedRoute><SubtitlePage /></ProtectedRoute>} />
        <Route path="/settings/manage-device" element={<ProtectedRoute><ManageDevicePage /></ProtectedRoute>} />
        <Route path="/settings/social-account" element={<ProtectedRoute><SocialAccountPage /></ProtectedRoute>} />
        <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettingsPage /></ProtectedRoute>} />
        <Route path="/settings/content-rating" element={<ProtectedRoute><ContentRatingPage /></ProtectedRoute>} />
        <Route path="/settings/parental/:name" element={<ProtectedRoute><ParentalDetailPage /></ProtectedRoute>} />
        <Route path="/settings/view-activity" element={<ProtectedRoute><ViewActivityPage /></ProtectedRoute>} />
        <Route path="/settings/profile-pin" element={<ProtectedRoute><ProfilePinPage /></ProtectedRoute>} />

        {/* ===== Legal Pages (public — accessible from footer) ===== */}
        <Route path="/terms" element={<TermsConditionsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />

        {/* ===== Payment Gateway Return (public — gateways may strip auth headers) ===== */}
        <Route path="/payment-callback" element={<PaymentCallbackPage />} />

        {/* Fallback — send authenticated users home, unauthenticated to login.
            Without PublicRoute here, any logged-in user landing on an unknown
            URL (e.g. a stale gateway redirect, a deploy that hasn't picked up
            a new route yet) sees the login form and assumes they've been
            logged out, even though their session is still valid. */}
        <Route path="*" element={<PublicRoute><LoginPage /></PublicRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
